import React, { useEffect, useState } from "react";
import "../style/chat-layout.css";
import IC_logo from "../../../../assets/images/1744877067.jpg";
import { useDispatch, useSelector } from "react-redux";
import { getClientProviderList, getAdminUserList } from "../slice/clientChatListSlice";
import { useNavigate, useParams, Outlet } from 'react-router-dom';
import ClientHeader from "../../client-header/components";
import Pusher from "pusher-js";
import { resetNotifications } from "../../client-navbar/slice/clientNavigationSlice";

const ClientChatList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { clientProviders: providers, clientLastMessages, adminUsers, adminLastMessages, loading } = useSelector(
    (state) => state.clientChatList
  );

  useEffect(() => {
    dispatch(resetNotifications());
  }, [dispatch, id]);

  const clientToken = localStorage.getItem("client_access_token");
  const token = clientToken;

  const [activeTab, setActiveTab] = useState("provider");
  const [filters, setFilters] = useState({
    keyword: "",
    status: ""
  });

  // Debounce search input
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilters((prev) => ({ ...prev, keyword: searchTerm }));
    }, 400); // 400ms debounce

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // Fetch data based on tab + filter
  useEffect(() => {
    if (activeTab === "provider") {
      console.log("filters", filters);
      dispatch(getClientProviderList({ filters, token }));
    } else {
      dispatch(getAdminUserList({ filters, token }));
    }
  }, [dispatch, activeTab, filters, token]);

    useEffect(() => {
  if (!token) return;

  const pusher = new Pusher("71055cc21a087085dc31", {
    cluster: "ap2",
    forceTLS: true,
    authEndpoint: `${process.env.REACT_APP_BACKEND_URL}/pusher/auth`,
  });

  // Subscribe to all chat channels from lastMessages
  const allChats = [...(clientLastMessages || []), ...(adminLastMessages || [])];

  const channels = [];

  allChats.forEach((chat) => {
    const chatChannel = pusher.subscribe(`private-chat_${chat.chat_id}`);

    chatChannel.bind("App\\Events\\MessageSent", (data) => {
      console.log("data", data);
      dispatch(resetNotifications());
      // Optionally: Only update if message is for the current user
      const currentUserId = localStorage.getItem("user_id");
      const currentUserType = "Icommunetech\\Client\\Models\\Client";

      const isToMe =
        data.message.to_id.toString() === currentUserId &&
        data.message.to_type === currentUserType;

      if (isToMe) {
        dispatch(resetNotifications());
        // Refresh the last messages list
        if (activeTab === "provider") {
          dispatch(getClientProviderList({ filters, token }));
        } else {
          dispatch(getAdminUserList({ filters, token }));
        }
      }
    });

    channels.push(chatChannel);
  });

  return () => {
    channels.forEach((channel) => {
      channel.unbind_all();
      channel.unsubscribe();
    });
    pusher.disconnect();
  };
}, [clientLastMessages, adminLastMessages, activeTab, dispatch, filters, token]);


useEffect(() => {
  if (!token) return;
Pusher.logToConsole = true;
  const pusher = new Pusher("71055cc21a087085dc31", {
    cluster: "ap2",
    forceTLS: true,
    authEndpoint: `${process.env.REACT_APP_BACKEND_URL}/pusher/auth`,
  });

  // const chatChannel = pusher.subscribe(`private-chat_${chat.chat_id}`);

  // 🔹 Subscribe to the global chat room channel
  const globalChannel = pusher.subscribe("private-chat_room");

  globalChannel.bind("App\\Events\\ChatRoomCreated", (data) => {
    console.log("ChatRoomCreated event received:", data);
    dispatch(resetNotifications());
     if (activeTab === "provider") {
      dispatch(getClientProviderList({ filters, token }));
    } else {
      dispatch(getAdminUserList({ filters, token }));
    }
  });

  return () => {
    globalChannel.unbind_all();
    globalChannel.unsubscribe();
    pusher.disconnect();
  };
}, [activeTab, dispatch, filters, token]);


  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    setFilters({ keyword: "", status: "" }); // clear filters on switch
    setSearchTerm("");
    navigate(`/client/chat/${tab}`);
  };

  const renderList = activeTab === "provider" ? providers : adminUsers;
  const recentList = activeTab === "provider" ? clientLastMessages : adminLastMessages;

  return (
    <>
      <ClientHeader />
      <div className="chat-layout">
        <div className="chat-sidebar">
          <div className="tab-buttons">
            <button
              className={activeTab === "provider" ? "active" : ""}
              onClick={() => handleTabSwitch("provider")}
            >
              Provider
            </button>
            <button
              className={activeTab === "admin" ? "active" : ""}
              onClick={() => handleTabSwitch("admin")}
            >
              Admin
            </button>
          </div>

          {/* Search input */}
          <div style={{ padding: "0 10px 10px" }}>
            <input
              type="text"
              placeholder={`Search ${activeTab === "provider" ? "Provider" : "Admin"}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            />
          </div>

{/* Provider Section */}
{activeTab === "provider" && (
  <>
    {clientLastMessages?.length > 0 && (
      <div className="recent-chats-section" style={{ padding: "0 10px" }}>
        <h4 style={{ marginBottom: "8px" }}>Recent Chats</h4>
        {/* {clientLastMessages.map((user) => (
          <div
            key={`recent-provider-${user.id}`}
            className={`chat-list-item ${id === String(user.from_id) ? "active" : ""}`}
            onClick={() => navigate(`/client/chat/provider/${user.from_id}/${user.chat_id}`)}
          >
            <img src={IC_logo} alt={user.name} className="chat-avatar" />
            <div className="chat-list-details">
              <div className="chat-name">
                {user.from_type === "Icommunetech\\Client\\Models\\Client" ? user.to_name :
                user.from_type === "Icommunetech\\Provider\\Models\\Provider" ? user.from_name : ""}
              </div>

              <div className="chat-status">
                Last message: {
                  user.message 
                    ? user.message 
                    : user.file_path 
                      ? "📎 Attachment" 
                      : "No message"
                }
              </div>

            </div>
          </div>
        ))} */}
        {clientLastMessages.map((user) => {
  // Calculate targetId inside map, where user is defined
  const targetId = user.from_type === "Icommunetech\\Client\\Models\\Client"
    ? user.to_id
    : user.from_type === "Icommunetech\\Provider\\Models\\Provider"
      ? user.from_id
      : null;

      const displayName = user.from_type === "Icommunetech\\Client\\Models\\Client"
    ? user.to_name
    : user.from_type === "Icommunetech\\Provider\\Models\\Provider"
      ? user.from_name
      : "";

  return (
    <div
      key={`recent-provider-${targetId}`}
      className={`chat-list-item ${id === String(targetId) ? "active" : ""}`}
      onClick={() => navigate(`/client/chat/provider/${targetId}/${user.chat_id}?name=${encodeURIComponent(displayName)}`)}
    >
      <img src={IC_logo} alt={user.name} className="chat-avatar" />
      <div className="chat-list-details">
        <div className="chat-name">
          {user.from_type === "Icommunetech\\Client\\Models\\Client"
            ? user.to_name
            : user.from_type === "Icommunetech\\Provider\\Models\\Provider"
              ? user.from_name
              : ""}
        </div>

        <div className="chat-status">
          Last message: {user.message ? user.message : user.file_path ? "📎 Attachment" : "No message"}
        </div>
      </div>
    </div>
  );
})}

      </div>
    )}

    <div className="all-users-section" style={{ padding: "0 10px" }}>
      <h4 style={{ margin: "16px 0 8px" }}>All Providers</h4>
     {providers.map((user) => (
  <div
    key={`provider-${user.id}`}
    className={`chat-list-item ${id === String(user.id) ? "active" : ""}`}
    onClick={() => {
      const targetName = encodeURIComponent(user.company_name || user.name);
      navigate(`/client/chat/provider/${user.id}/-?name=${targetName}`);
    }}
  >
    <img src={IC_logo} alt={user.company_name || user.name} className="chat-avatar" />
    <div className="chat-list-details">
      <div className="chat-name">{user.company_name || user.name}</div>
      <div className="chat-status">Status: {user.status || "active"}</div>
    </div>
  </div>
))}


    </div>
  </>
)}

{/* Admin Section */}
{activeTab === "admin" && (
  <>
    {adminLastMessages?.length > 0 && (
      <div className="recent-chats-section" style={{ padding: "0 10px" }}>
        <h4 style={{ marginBottom: "8px" }}>Recent Chats</h4>
        {adminLastMessages.map((user) => {
          const targetId = user.from_type === "App\\Models\\User"
    ? user.from_id
    : user.from_type === "Icommunetech\\Client\\Models\\Client"
      ? user.to_id
      : null;

      const displayName = user.from_type === "App\\Models\\User"
    ? user.from_name
    : user.from_type === "Icommunetech\\Client\\Models\\Client"
      ? user.to_name
      : "";
      return (
          <div
            key={`recent-admin-${targetId}`}
            className={`chat-list-item ${id === String(targetId) ? "active" : ""}`}
            onClick={() => navigate(`/client/chat/admin/${targetId}/${user.chat_id}?name=${encodeURIComponent(displayName)}`)}
          >
            <img src={IC_logo} alt={user.name} className="chat-avatar" />
            <div className="chat-list-details">
              <div className="chat-name">
          {user.from_type === "App\\Models\\User"
            ? user.from_name
            : user.from_type === "Icommunetech\\Client\\Models\\Client"
              ? user.to_name
              : ""}
        </div>
              <div className="chat-status">Last message: {user.message || "No message"}</div>
            </div>
          </div>
      );
})}
      </div>
    )}

    <div className="all-users-section" style={{ padding: "0 10px" }}>
      <h4 style={{ margin: "16px 0 8px" }}>All Admins</h4>
      {adminUsers.map((user) => (
        <div
          key={`admin-${user.id}`}
          className={`chat-list-item ${id === String(user.id) ? "active" : ""}`}
          onClick={() => navigate(`/client/chat/admin/${user.id}/-?name=${user.name}`)}
        >
          <img src={IC_logo} alt={user.company_name || user.name} className="chat-avatar" />
          <div className="chat-list-details">
            <div className="chat-name">{user.company_name || user.name}</div>
            <div className="chat-status">Status: {user.status || "active"}</div>
          </div>
        </div>
      ))}
    </div>
  </>
)}
        </div>

        <div className="chat-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ClientChatList;
